// extracted by mini-css-extract-plugin
export var actionButton = "_7v-0";
export var attachmentLine = "_7v-1";
export var fileInput = "_7v-2";
export var fileUploadWrapper = "_7v-4";
export var footer = "_7v-3";
export var modalContent = "_7v-5";
export var paperclip = "_7v-6";
export var quillEditor = "_7v-7";